var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbAlexa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.8379 18H42.5328C39.2159 18 36.527 20.6889 36.527 24.0058V96.0334C36.527 99.3503 39.2159 102.039 42.5328 102.039H76.8379C80.1549 102.039 82.8437 99.3503 82.8437 96.0334V24.0058C82.8437 20.6889 80.1549 18 76.8379 18Z",
    fill: "#006469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8437 89.2649V96.0334C82.8437 99.3486 80.1561 102.039 76.8379 102.039H42.5328C39.2146 102.039 36.527 99.3486 36.527 96.0334V89.2649C36.527 92.5831 39.2146 95.2707 42.5328 95.2707H76.8379C80.1561 95.2707 82.8437 92.5831 82.8437 89.2649Z",
    fill: "#025656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8437 29.381H36.527V31.7983H82.8437V29.381Z",
    fill: "#F9B147"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8437 29.381H36.527V30.2188H82.8437V29.381Z",
    fill: "#F79C16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M82.8437 31.7983H36.527V61.7763H82.8437V31.7983Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8437 31.7983H36.527V34.597H82.8437V31.7983Z",
    fill: "#006469"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1721 49.8878C49.8837 49.8878 51.2712 48.5003 51.2712 46.7888C51.2712 45.0773 49.8837 43.6898 48.1721 43.6898C46.4606 43.6898 45.0731 45.0773 45.0731 46.7888C45.0731 48.5003 46.4606 49.8878 48.1721 49.8878Z",
    fill: "#00C7CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6853 49.8878C61.3968 49.8878 62.7843 48.5003 62.7843 46.7888C62.7843 45.0773 61.3968 43.6898 59.6853 43.6898C57.9738 43.6898 56.5863 45.0773 56.5863 46.7888C56.5863 48.5003 57.9738 49.8878 59.6853 49.8878Z",
    fill: "#00C7CF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1954 49.8878C72.9069 49.8878 74.2944 48.5003 74.2944 46.7888C74.2944 45.0773 72.9069 43.6898 71.1954 43.6898C69.4839 43.6898 68.0964 45.0773 68.0964 46.7888C68.0964 48.5003 69.4839 49.8878 71.1954 49.8878Z",
    fill: "#00C7CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbAlexa);
export default __webpack_public_path__ + "static/media/bb-alexa.705cef9b32f2581a696851559a10a742.svg";
export { ForwardRef as ReactComponent };